export const ACCOUNT_STATE_FIXTURES = Object.freeze({
    freeLowCredits: Object.freeze({ tierId: 'free', creditsTotal: 0, entitlementKind: 'free' }),
    standardLowCredits: Object.freeze({ tierId: 'standard', creditsTotal: 0, entitlementKind: 'subscription' }),
    standardEnoughCredits: Object.freeze({ tierId: 'standard', creditsTotal: 5, entitlementKind: 'subscription' }),
    proEnoughCredits: Object.freeze({ tierId: 'pro', creditsTotal: 20, entitlementKind: 'subscription' })
});

export const IMAGE_UNLOCK_STATE_FIXTURES = Object.freeze({
    notUnlocked: Object.freeze({ imageId: 'image-1', unlockedFeatures: [] }),
    guideLuminosityUnlocked: Object.freeze({
        imageId: 'image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'result_guide', subFeatureCode: 'luminosity_histogram' }])
    }),
    comparePointInspectorUnlocked: Object.freeze({
        imageId: 'image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'compare', subFeatureCode: 'point_inspector' }])
    }),
    same_image_revisit: Object.freeze({
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'compare', subFeatureCode: 'point_inspector' }]),
        updatedAt: 1711843200000,
        version: 'v2'
    }),
    refresh_restore: Object.freeze({
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'result_guide', subFeatureCode: 'luminosity_histogram' }]),
        updatedAt: 1711846800000,
        version: 'v3'
    }),
    cross_user: Object.freeze({
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'atomic_capability', subFeatureCode: 'global_color_palette' }]),
        updatedAt: 1711850400000,
        version: 'user-b-v1'
    }),
    cross_image: Object.freeze({
        imageId: 'history-image-2',
        unlockedFeatures: Object.freeze([]),
        updatedAt: 1711854000000,
        version: 'v1'
    })
});

export const RESULT_SCOPE_UNLOCK_STATE_FIXTURES = Object.freeze({
    same_scope_revisit: Object.freeze({
        scopeKey: 'history-image-1::preset-1',
        scopeType: 'reference',
        originalHashId: 'history-image-1',
        presetStyleId: 'preset-1',
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'compare', subFeatureCode: 'point_inspector' }]),
        updatedAt: 1711843200000,
        version: 'scope-v2'
    }),
    another_reference_locked: Object.freeze({
        scopeKey: 'history-image-1::preset-2',
        scopeType: 'reference',
        originalHashId: 'history-image-1',
        presetStyleId: 'preset-2',
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([]),
        updatedAt: 1711845000000,
        version: 'scope-v1'
    }),
    solo_scope_locked: Object.freeze({
        scopeKey: 'history-image-1::__solo__',
        scopeType: 'solo',
        originalHashId: 'history-image-1',
        presetStyleId: null,
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([]),
        updatedAt: 1711846800000,
        version: 'scope-v1'
    }),
    cross_user_scope: Object.freeze({
        scopeKey: 'history-image-1::preset-1',
        scopeType: 'reference',
        originalHashId: 'history-image-1',
        presetStyleId: 'preset-1',
        imageId: 'history-image-1',
        unlockedFeatures: Object.freeze([{ featureCode: 'atomic_capability', subFeatureCode: 'global_color_palette' }]),
        updatedAt: 1711850400000,
        version: 'user-b-scope-v1'
    })
});

export const SESSION_ACTION_STATE_FIXTURES = Object.freeze({
    idle: Object.freeze({ inflightActionMap: Object.freeze({}) }),
    guideLuminosityUnlocking: Object.freeze({
        inflightActionMap: Object.freeze({ 'result_guide::luminosity_histogram': true })
    })
});

export const PHASE_A_STATE_FIXTURES = Object.freeze({
    accountStates: ACCOUNT_STATE_FIXTURES,
    imageUnlockStates: IMAGE_UNLOCK_STATE_FIXTURES,
    resultScopeUnlockStates: RESULT_SCOPE_UNLOCK_STATE_FIXTURES,
    sessionStates: SESSION_ACTION_STATE_FIXTURES
});
